<template>
  <pi-content className="white">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text=""
      @load="onLoad"
    >
      <div class="list-item pi-flex pi-divider pi-center-items" v-for="item in list" :key="item" :title="item">
        <img src="../../assets/img/d72e70cc40071d5964794636618a9d3.png">
        <div class="pi-flex-item padding-left-normal">
          <div class="text-size-32 text-color-second">原路退回到微信钱包</div>
          <div class="text-size-24 text-color-third margin-top-normal">2020-03-04  13:33:33</div>
        </div>
        <div>
          <div class="text-size-32 text-color-first" style="font-weight: 500">¥456</div>
          <div class="text-size-24 text-color-third margin-top-normal">可退款</div>
        </div>
        <img style="width: 0.3rem; height: 0.3rem; margin-left: 0.2rem" src="../../assets/img/icon-right.png"
             alt="">
      </div>
    </van-list>
  </pi-content>
</template>

<script>
// import { queryRefundRecord } from '@/common/api/index';
import { List } from 'vant';
export default {
  name: 'my-recharge-record',
  components: {
    [List.name]: List
  },
  data () {
    return {
      allLoaded: false,
      style: {},

      chargeForm: {
        PageIndex: 1,
        PageSize: 20,
        endTime: '2019-07-22 23:59:59',
        startTime: '2019-05-01 00:00:00'
      },
      chargeList: [],
      chargeTotal: 0,
      refundStatus: {
        '-1': '平台审核中',
        '0': '微信申请中',
        '1': '退款成功',
        '2': '退款异常',
        '3': '退款拒绝'
      },
      refundError: {
        '-1': 'blue',
        '0': 'blue',
        '1': 'green',
        '2': 'red',
        '3': 'red'
      },
      list: [],
      loading: false,
      finished: false
    };
  },
  methods: {
    onLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      setTimeout(() => {
        for (let i = 0; i < 10; i++) {
          this.list.push(this.list.length + 1);
        }

        // 加载状态结束
        this.loading = false;

        // 数据全部加载完成
        if (this.list.length >= 40) {
          this.finished = true;
        }
      }, 1000);
    },
    loadBottom () {
      this.chargeForm.PageIndex++;
      this.refundinfosRecord();
    },

    async refundinfosRecord () {
      // let ret = await queryRefundRecord(this.chargeForm);
      // if (ret.status === this.$config.ajaxStatus) {
      //   let arr = [];
      //   ret.data.records.map(item => {
      //     // let text = item.refundStatus === 1 ? item.refundRecvAccout : item.refundStatus === -1 ? item.refundDesc : item.returnMsg;
      //     let obj = {
      //       name: item.refundFee + '元', // item.outRefundNo,
      //       smallName: item.applyrefundtime,
      //       amount: this.refundStatus[item.refundStatus], // item.refundFee + '元',
      //       // amountText: item.refundDesc,
      //       payType: 3,
      //       statusClassName: this.refundError[item.refundStatus]
      //     };
      //     obj = Object.assign(obj, item);
      //     arr.push(obj);
      //   });
      //
      //   this.chargeList = this.chargeList.concat(arr);
      //   this.chargeTotal = ret.data.total;
      //   if (this.chargeList.length >= ret.data.total) {
      //     this.allLoaded = true;
      //   }
      // }
      // this.$refs.loadmore.onBottomLoaded();
    },
    recordClick (item) {
      this.$common.save('cashRecordDetails', item);
      this.$router.push('/my/cash/custom/details');
    }
  },
  created () {
    // this.refundinfosRecord();
  },
  mounted () {
    // this.$nextTick(() => {
    //   let height = this.$common.getWinHeight();
    //   this.style = { height: (height) + 'px' };
    // });
  }
};
</script>

<style lang="less" scoped>
.my-bill {
  position: relative;
  .page-loadmore {
    box-sizing: border-box;
  }
  .change-ul {
    padding: 0.2rem;
  }
}
.list-item {
  margin: 0 0.2rem;
  padding: 0.2rem 0;
  img {
    width: 0.8rem;
    height: 0.8rem;
  }
}
</style>
